module.exports = __webpack_public_path__ + "static/img/visa.da35dfc8.svg";